<template>
  <div class="chart_con">
    <div :ref="graphName" class="graph_con"></div>
  </div>
</template>

<script>
import _ from 'lodash'
import { h as GraphVis } from '@/assets/js/graphvis.esm.min.js';
import { getNodeColor, linkColor, getTargetColor } from '@/api/portrait.js'

export default {
  props: {
    chartName: String,
  },
  components: {
  },
  data() {
    return {
      graphName: '',
      currCenter: null,
      currNode: null,
      graphVis: null,
      rootId: '',
      graphData: {},
    }
  },
  methods: {
    destroy() {
      this.graphVis && (this.graphVis.clearAll(), this.graphVis.destroy());
      this.graphVis = null;
    },
    async setOption() {
      await this.destroy();
      this.$nextTick(() => {
        // 通过 ref 获取容器元素
        const graphContainer = this.$refs[this.graphName];
        this.graphVis = new GraphVis({
          container: graphContainer,
          licenseKey: 'online-demo',
          config: {
            node: {
              label: {
                show: true,
                color: '255,255,255',
                font: 'normal 10px YaHei'
              },
              shape: 'circle',
              size: 60,
              borderWidth: 6,
              borderColor: '255,255,255',
              selected: {
                borderWidth: 6,
                borderColor: '80,100,240',
                showShadow: false, //是否展示阴影
                shadowColor: '80,100,240', //选中是的阴影颜色
                shadowBlur: 6 //阴影的范围大小
              }
            },
            link: {
              label: {
                show: true,
                color: '209,209,209',
                font: 'normal 10px YaHei',
                background: null
              },
              lineType: 'straight',
              lineWidth: 2,
              alpha: 1,
              color: '209,209,209',
              showArrow: true,
              arrowType: 'triangle',//箭头样式arrow,triangle
              selected: {
                color: '80,100,240',
              }
            },
            highLightNeiber: true, //相邻节点高度标志
          }
        });
        this.initGraph();
      })
    },
    initGraph() {
      const self = this;
      // this.graphVis.setZoomRange([0.1, 4]); //放区间
      this.graphVis.setShowDetailScale(0.3); //显示细节文字的最小比例

      this.graphVis.registEventListener('node', 'click', function (event, node) {
        self.onNodeClick(node);
      });

      this.graphVis.registEventListener('scene', 'whiteSpaceClick', function (event, client) {
        self.graphVis.restoreHightLight();
        self.onNodeClick();
      });

      let nodeColor = {};
      for (var i = 0; i < 12; i++) {
        nodeColor[i + 1] = {
          size: (i <= 2 || i == 9 || i == 10) ? 60 : (i == 3 || i == 4 || i == 6 || i == 8) ? 90 : 100,
          color: getNodeColor(i + 1).rgb,
          selectedBorderColor: getNodeColor(i + 1).borderRgb,
        };
      }
      //配置节点类型显示样式(支持大小，颜色，形状，图片的统一配置)
      this.graphVis.reConfigNodeCluster(nodeColor);
      //统一配置连线类型（对应连线的type属性）的显示样式(支持类型，粗细，颜色，虚线样式)
      this.graphVis.reConfigLinkCluster(linkColor);
      // this.graphVis.reConfigLinkCluster({
      //   default: { color: '209,209,209', selectedColor: '254,104,104' }
      // });

      this.loadChart();
    },
    // 渲染关系图谱
    loadChart() {
      const self = this;
      let { nodes, links } = this.graphData;
      const nodeBatchSize = 100;
      let currentNodeIndex = 0;
      // 分批加载函数
      const loadNextBatch = () => {
        const nodeEndIndex = Math.min(currentNodeIndex + nodeBatchSize, nodes.length);
        const batchNodes = nodes.slice(currentNodeIndex, nodeEndIndex);

        // 处理节点样式
        batchNodes.forEach(node => {
          node.properties = { ...node };
          node.label = this.truncateLabel(node.label, 20);
          node.style = {
            nodeWrapText: true, //设置为文字包裹效果
            wrapTextConfig: { //文字配置
              isVertical: false,
              fontSize: 10,
              fontFamily: 'YaHei',
              padding: 15
            }
          };
          //设置样式
          if (node.id == self.rootId) {
            node.style.size = 110;
            node.style.wrapTextConfig.fontSize = 14;
            node.style.fillColor = '51, 23, 183'; //rgb(51, 23, 183) rgb(70,165,255)
            node.style.selectedBorderColor = '198,208,248';// rgb(198,208,248)
          }
        });

        // 添加节点和连线
        self.graphVis.addNodes(batchNodes);

        currentNodeIndex = nodeEndIndex;

        if (currentNodeIndex < nodes.length) {
          // 继续加载下一批
          setTimeout(loadNextBatch, 200);
        } else {
          // 所有批次加载完成
          links.forEach((link, l) => {
            link.id = 'edge-' + l;
            link.properties = { ...link }
          })
          self.graphVis.addEdges(links);
          self.runLayout();
        }
      };

      // 开始加载第一批
      loadNextBatch();
    },
    truncateLabel(str, maxLength = 34) {
      // 计算字符串的实际占位长度（汉字算2，英文数字算1）
      let length = 0;
      for (let i = 0; i < str.length; i++) {
        const char = str[i];
        // 判断是否为汉字（粗略判断）
        length += char.charCodeAt(0) > 255 ? 2 : 1;

        // 如果超过最大长度，截断并加省略号
        if (length > maxLength * 2) {
          return str.substring(0, i) + '...';
        }
      }
      // 如果没有超过长度，返回原字符串
      return str;
    },
    runLayout(layoutType = 'fastForce') {
      // 网络布局
      const self = this;
      let layoutConfig = {
        'friction': 0.95,  //排斥力
        'linkDistance': 150, // 连线长度
        'linkStrength': 0.09, //连线强度
        'charge': -300,  //吸引力
        'gravity': 0.015, // 中心引力
      };
      //布局参数（详细请查看开发文档）
      if (layoutType == 'arf') { // 球面引力布局
        layoutConfig = {
          neighberForce: 5.0,
          attraction: 0.05,
          forceScale: 5.0
        }
      } else if (layoutType == 'simulation') { // 力导向布局
        layoutConfig = { strength: -3000, ajustCluster: true };
      } else if (layoutType == 'avoidlap') { // 避免重叠布局
        layoutConfig = { maxPadding: 10 };
      } else if (layoutType == 'kawakai') { // 最优路径布局
        layoutConfig = { sizeScale: 0.8 }
      }
      this.$emit('openLoading', false);
      // this.graphVis.hideLoadProcess();
      this.graphVis.excuteWorkerLayout(self.graphVis.getGraphData(), layoutType, layoutConfig, false, function () {
        // self.graphVis.refreshView();
        self.graphVis.zoomFit(); //布局结束缩放居中
      });
    },
    /**
     * 1.选中中心节点：高亮整个关系图
     * 2.选中非中心节点：
     *  a.中心节点为人员（centerData.type == '1'）
     *    1.点击节点的连线为服务网络：则在人员的连线中找出relationNodeId包含item.id的线，高亮这些线和线的target节点；
     *    2.点击节点的连线为供应网络：则高亮节点及其邻居节点和连线，并高亮邻居节点的所有连线和连线两端的节点；
     *    3.点击节点的连线为触达网络：则高亮节点连线中relationNodeId包含的节点并高亮该节点连线中指向中心节点的连线；
     *    4.点击节点的连线为销售网络：
     *      a.若点击节点为产品（item.type == '9'），则直接高亮节点及其邻居节点和连线；
     *      b.若点击节点不为产品，则高亮节点及其邻居节点和连线，并高亮邻居节点中为产品的节点的邻居节点及连线；
     *  b.中心节点为医院（centerData.type == '4'）或 商业公司（centerData.type == '6'）
     *    1.中心节点为医院
     *      a.若点击节点为科室，则高亮节点及其邻居节点和连线，并高亮节点连线中relationNodeId包含的节点和该节点向外指出的连线;
     *      b.若点击节点为医生，则高亮节点及其邻居节点和连线，并高亮中心节点和指向其关联的医生的连线，以及高亮节点中relationNodeId包含的节点和该节点向外指出的连线；
     *      c.若点击节点为服务人员，则高亮节点及其邻居节点和连线，并高亮其他连线中relationNodeId包含该节点的连线和连线的target节点；
     *      d.若点击节点为其他类型的节点，则高亮节点及其邻居节点和连线，且高亮中心节点以及点击节点的邻居节点指向中心节点的连线，并高亮其他连线中relationNodeId包含该节点的连线和连线的target节点以及中心节点指向target节点的连线；
     *    2.中心节点为商业公司
     *      a.若点击节点为部门，则高亮节点及其邻居节点和连线，并高亮节点连线中relationNodeId包含的节点和该节点向外指出的连线;
     *      b.若点击节点为联系人，则高亮节点及其邻居节点和连线，并高亮中心节点和指向其关联的部门的连线，以及高亮节点中relationNodeId包含的节点和该节点向外指出的连线；
     *      c.若点击节点为服务人员，则高亮节点及其邻居节点和连线，并高亮其他连线中relationNodeId包含该节点的连线和连线的target节点；
     *      d.若点击节点为其他类型的节点，则高亮节点及其邻居节点和连线，且高亮中心节点以及点击节点的邻居节点指向中心节点的连线，并高亮其他连线中relationNodeId包含该节点的连线和连线的target节点以及中心节点指向target节点的连线；
     *  c.中心节点为其他类型
     *      1.点击节点,高亮节点及其邻居节点和连线
    **/
    onNodeClick(node) {
      console.log(node);
      this.$emit('nodeClick', node)
      if (!node) return
      const self = this;
      // 中心节点
      const centerData = this.currCenter.node || this.currCenter;

      const graphEdges = self.graphVis.getEdges()
      const graphNodes = self.graphVis.getNodes();
      // 设置高亮
      if (node.id == centerData.id) {
        graphEdges.forEach(edge => {
          self.graphVis.hilightdEdge(edge);
          const edgePro = edge.properties;
          const type = getTargetColor(edgePro.rel_type, edgePro.label == '触达网络' ? centerData.type : edgePro.label == '物流网络' ? edgePro.labelName : edgePro.label == '销售网络'? {type: edgePro.labelName, isCenter: edgePro.target == centerData.id} : null);
          edge.fontColor = linkColor[type].selectedColor;
        });
      } else {
        const neighborEdges = self.graphVis.getNeighborEdges(node);
        const neighborNodes = self.graphVis.getNeighborNodes(node);

        // 高亮连线及连线文字
        const highlightEdges = (edges, lightNode = true) => {
          edges.forEach(edge => {
            self.graphVis.hilightdEdge(edge, lightNode);
            const edgePro = edge.properties;
            const type = getTargetColor(edgePro.rel_type, edgePro.label == '触达网络' ? centerData.type : edgePro.label == '物流网络' ? edgePro.labelName : edgePro.label == '销售网络'? {type: edgePro.labelName, isCenter: edgePro.target == centerData.id} : null);
            edge.fontColor = linkColor[type].selectedColor;
          });
        }

        // 高亮 relationNodeId 包含的节点以及指向tid的节点和连线
        const highlightRelatedNodes = (link) => {
          const ids = link.relationNodeId || [];
          ids.forEach((rNodeId, r) => {
            const rid = graphNodes.find(n => n.properties.damId === rNodeId)?.id || null;
            if (!rid) return;
            const rNode = self.graphVis.getNodeById(rid);
            const rOutEdges = self.graphVis.getOutEdges(rNode);
            rOutEdges.forEach(oe => {
              oe.target.id == centerData.id && self.graphVis.hilightdEdge(oe);
              oe.source.id == rid && self.graphVis.hilightdEdge(oe);
            })
          });
        }

        // 高亮当前节点的连线和连线文字
        highlightEdges(neighborEdges);
        // 选中产品只需高亮相邻节点和连线
        if (node.type == '9') return

        if (centerData.type == '1') {
          if (neighborEdges[0].label == '服务网络') {
            const targetEdges = graphEdges.filter(e => e.properties.relationNodeId && e.properties.relationNodeId.join('').indexOf(node.properties.damId) > -1);
            targetEdges.length && highlightEdges(targetEdges);
          } else if (neighborEdges[0].label == '触达网络') {
            neighborEdges.map(e => {
              (() => {
                highlightRelatedNodes(e.properties)
              })()
            });
          } else if (neighborEdges[0].label == '供应网络') {
            neighborNodes.map(n => {
              const nEdges = self.graphVis.getNeighborEdges(n);
              const hEdges = nEdges.filter(e => e.properties.relationNodeId && e.properties.relationNodeId.join('').indexOf(node.properties.damId) > -1);
              hEdges.length && highlightEdges(hEdges)
            })
          } else if (neighborEdges[0].label == '销售网络') {
            const nNodes = neighborNodes.filter(n => n.type == '9');
            nNodes.map(n => {
              const nEdges = self.graphVis.getNeighborEdges(n);
              const hEdges = nEdges.filter(e => e.target.id === n.id);
              hEdges.length && highlightEdges(hEdges)
            })
          }
        } else if (centerData.type == '4') {
          if (node.type == '10' || node.type == '2') {
            neighborEdges.map(e => {
              (() => {
                highlightRelatedNodes(e.properties)
              })()
            });
            neighborNodes.map(n => {
              const iEdges = self.graphVis.getInEdges(n);
              const cEdges = iEdges.filter(ie => ie.source.id == centerData.id);
              cEdges.length && highlightEdges(cEdges);
            })
          } else if (node.type == '1') {
            const targetEdges = graphEdges.filter(e => e.properties.relationNodeId && e.properties.relationNodeId.join('').indexOf(node.properties.damId) > -1);
            targetEdges.length && highlightEdges(targetEdges);
          } else {
            const targetEdges = graphEdges.filter(e => e.properties.relationNodeId && e.properties.relationNodeId.join('').indexOf(node.properties.damId) > -1);
            targetEdges.length && highlightEdges(targetEdges);
            neighborNodes.map(n => {
              const oEdges = self.graphVis.getOutEdges(n);
              const cEdges = oEdges.filter(oe => oe.target.id == centerData.id);
              cEdges.length && highlightEdges(cEdges);
            })
          }
        } else if (centerData.type == '6') {
          if (node.type == '11' || node.type == '3') {
            neighborEdges.map(e => {
              (() => {
                highlightRelatedNodes(e.properties)
              })()
            });
            neighborNodes.map(n => {
              const iEdges = self.graphVis.getInEdges(n);
              const cEdges = iEdges.filter(ie => ie.source.id == centerData.id);
              cEdges.length && highlightEdges(cEdges);
            })
          } else if (node.type == '1') {
            const targetEdges = graphEdges.filter(e => e.properties.relationNodeId && e.properties.relationNodeId.join('').indexOf(node.properties.damId) > -1);
            targetEdges.length && highlightEdges(targetEdges);
          } else {
            neighborNodes.map(n => {
              const nEdges = self.graphVis.getNeighborEdges(n);
              nEdges.map(ne => {
                ne.target.id == centerData.id && self.graphVis.hilightdEdge(ne);
                ne.source.id == centerData.id && self.graphVis.hilightdEdge(ne);
              })
            })
          }
        } else if (centerData.type == '8') {
          if (node.type != '1') {
            neighborNodes.map(n => {
              const nEdges = self.graphVis.getNeighborEdges(n);
              nEdges.map(ne => {
                ne.target.id == centerData.id && self.graphVis.hilightdEdge(ne);
                ne.source.id == centerData.id && self.graphVis.hilightdEdge(ne);
              })
            })
          }
        } else {
          if (centerData.type != '9') {
            if (neighborEdges[0].label == '供应网络') {
              neighborNodes.map(n => {
                const nEdges = self.graphVis.getNeighborEdges(n);
                const hEdges = nEdges.filter(e => e.properties.relationNodeId && e.properties.relationNodeId.join('').indexOf(node.properties.damId) > -1);
                hEdges.length && highlightEdges(hEdges)
              })
            } else if (neighborEdges[0].label == '物流网络') {
              neighborNodes.map(n => {
                const nEdges = self.graphVis.getNeighborEdges(n);
                const hEdges = nEdges.filter(e => e.target.id == centerData.id);
                hEdges.length && highlightEdges(hEdges)
              })
            }
          }
        }
      }
    },
    chartResize() {
      this.$nextTick(() => {
        this.graphVis.resize();
      })
    },
    getImage() {
      return this.graphVis.getSnapshotImage();
    },
    saveImage() {
      const name = this.currCenter.node ? this.currCenter.node.label : this.currCenter.label;
      this.graphVis.saveImage({ fileName: name, textWatermark: { content: '全景流通数字地图' } });
    }
  }
}
</script>

<style lang="less" scoped>
.chart_con {
  width: 100%;
  height: 100%;
  position: absolute;
  // min-height: 640px;

  .graph_con {
    width: 100%;
    height: 100%;
  }
}
</style>
